// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Ghp4","rootMobile":"styles_rootMobile__2cLO5"};